/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IAaiVisitor } from '../visitors/IAaiVisitor';
import { Node } from '../../core/models/Node';
import { IDefinition } from '../../core/models/common/IDefinition';
import { IVisitor } from '../../core/visitors/IVisitor';
import { AaiMessageBindings } from './AaiMessageBindings';

/**
 * Constructor.
 * @param {Node} parent
 * @param {string} name
 * @class
 * @extends AaiMessageBindings
 * @author eric.wittmann@gmail.com
 */
export abstract class AaiMessageBindingsDefinition extends AaiMessageBindings implements IDefinition {
    public _name : string;

    public constructor(parent? : any, name? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null) && ((typeof name === 'string') || name === null)) {
            let __args = arguments;
            super(parent);
            if(this._name===undefined) this._name = null;
            if(this._name===undefined) this._name = null;
            (() => {
                this._name = name;
            })();
        } else if(((typeof parent === 'string') || parent === null) && name === undefined) {
            let __args = arguments;
            let name : any = __args[0];
            super();
            if(this._name===undefined) this._name = null;
            if(this._name===undefined) this._name = null;
            (() => {
                this._name = name;
            })();
        } else if(((parent != null && parent instanceof <any>Node) || parent === null) && name === undefined) {
            let __args = arguments;
            super(parent);
            if(this._name===undefined) this._name = null;
            if(this._name===undefined) this._name = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasHeader#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IAaiVisitor = <IAaiVisitor><any>visitor;
        viz.visitMessageBindingsDefinition(this);
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#getName()
     * @return {string}
     */
    public getName() : string {
        return this._name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#rename(java.lang.String)
     * @param {string} newName
     */
    public rename(newName : string) {
        this._name = newName;
    }
}
AaiMessageBindingsDefinition["__class"] = "io.apicurio.datamodels.asyncapi.models.AaiMessageBindingsDefinition";
AaiMessageBindingsDefinition["__interfaces"] = ["io.apicurio.datamodels.core.models.common.IDefinition","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.common.INamed"];




